import React from 'react'
import useSWR from 'swr'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatTile from '../../shared/StatTile'

export default withTranslation()(function POSSummary({ t }) {
  const { data } = useSWR('pos')
  const devices = data?.data ?? []
  const active = devices.filter((device) => device.status === 'active').length

  return (
    <div className="grid gap-4 md:grid-cols-3 mb-5">
      <StatTile
        icon={UIcons.UilCalculator}
        label={t('settings.business_organization.pos.total')}
        value={devices.length}
        tone="info"
        tinted
      />

      <StatTile
        icon={UIcons.UilCheckCircle}
        label={t('settings.business_organization.pos.active')}
        value={active}
        tone="success"
        tinted
      />

      <StatTile
        icon={UIcons.UilTimesCircle}
        label={t('settings.business_organization.pos.inactive')}
        value={devices.length - active}
        tone="danger"
        tinted
      />
    </div>
  )
})
